function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useContext } from "react";
import { Concert, LocationSearch, ResponsiveCheckbox } from "./components";
import { ThemeSwap, P, DistanceBetweenCoords, withDefaultMedia, FlexBox, LocationContext, Link } from "../";
import styled from "styled-components";
import { ReactComponent as LocationIconWhite } from "@svgr/webpack?-svgo,+titleProp,+ref!./location_icon_white.svg";
import { ReactComponent as LocationIconGray } from "@svgr/webpack?-svgo,+titleProp,+ref!./location_icon_gray.svg";
import { ReactComponent as IconCaret } from "@svgr/webpack?-svgo,+titleProp,+ref!../Icons/caret-next-disabled.svg";
import { useIntl, FormattedMessage } from "react-intl";
const ShowSelectorContainer = styled.div`
  display: block;
  width: 100%;
`;
const IconStyling = styled.div`
  display: inline-flex;
  margin-right: 8px;
  position: relative;

  @media only screen and ${props => props.theme.media.large} {
    margin-right: 10px;
  }
`;
const UpcomingContainer = styled.div`
  display: flex;
  margin-bottom: 8px;
  flex-wrap: wrap;
  align-items: center;
`;
const UpcomingText = styled(P)`
  padding-right: 4px;
  color: ${props => props.theme.dark ? props.theme.colors.locationTextDarkMode : props.theme.colors.inputPlaceholderText};

  @media only screen and ${props => props.theme.media.large} {
    color: ${props => props.theme.colors.inputPlaceholderText};
  }
`;
const HitArea = styled(FlexBox)`
  align-items: center;
  padding: 16px;
  cursor: pointer;
  margin: 8px 0;
  border-top: 1px solid ${props => props.theme.colors.borderLight};
  border-bottom: 1px solid ${props => props.theme.colors.borderLight};
`;
const NOT_ATTENDING = {
  id: 0
};
export const ShowSelector = withDefaultMedia(({
  matches,
  concerts,
  value,
  setValue,
  onNext
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    geolocation,
    setGeolocation
  } = useContext(LocationContext);
  const [expanded, setExpanded] = useState(false);

  const handleNotAttending = () => {
    if (value.includes(NOT_ATTENDING)) {
      return setValue([]);
    } else {
      return setValue([NOT_ATTENDING]);
    }
  };

  const handleSetValue = update => {
    return setValue(update.filter(option => option !== NOT_ATTENDING));
  };

  const handleNext = () => {
    setValue([NOT_ATTENDING]);
    onNext();
  };

  if (!geolocation) {
    return null;
  } else {
    const sortedConcerts = concerts.map(concert => {
      const distance = DistanceBetweenCoords(geolocation.latitude, geolocation.longitude, concert.venue.lat, concert.venue.lng);
      return { ...concert,
        distance
      };
    }).sort(({
      distance: distanceA
    }, {
      distance: distanceB
    }) => distanceA - distanceB);
    let i = 0;

    for (; sortedConcerts[i].distance < 100; i++) {}

    i = Math.max(i, 4);
    const nearby = sortedConcerts.slice(0, i);
    const remaining = sortedConcerts.slice(i);
    const sortedRemaining = remaining.sort(({
      date: dateA
    }, {
      date: dateB
    }) => {
      const arrA = dateA.split(/[- :]/);
      const arrB = dateB.split(/[- :]/);
      return new Date(arrA[0], arrA[1] - 1, arrA[2], arrA[3], arrA[4], arrA[5]) - new Date(arrB[0], arrB[1] - 1, arrB[2], arrB[3], arrB[4], arrB[5]);
    });
    return /*#__PURE__*/React.createElement(ShowSelectorContainer, null, /*#__PURE__*/React.createElement(FlexBox, null, /*#__PURE__*/React.createElement(UpcomingContainer, null, /*#__PURE__*/React.createElement(IconStyling, null, matches.large ? /*#__PURE__*/React.createElement(LocationIconGray, null) : /*#__PURE__*/React.createElement(ThemeSwap, {
      light: /*#__PURE__*/React.createElement(LocationIconGray, null),
      dark: /*#__PURE__*/React.createElement(LocationIconWhite, null)
    })), /*#__PURE__*/React.createElement(UpcomingText, null, formatMessage({
      id: "label.upcoming_concerts",
      defaultMessage: "Upcoming concerts near:"
    })), /*#__PURE__*/React.createElement(LocationSearch, {
      geolocation: geolocation,
      onChange: setGeolocation
    }))), nearby.map(concert => /*#__PURE__*/React.createElement(Concert, _extends({
      key: concert.id
    }, concert, {
      value: value,
      setValue: handleSetValue
    }))), sortedRemaining.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HitArea, {
      onClick: () => setExpanded(!expanded),
      "data-javelin-name": expanded ? "additional-concerts-collapse" : "additional-concerts-expand"
    }, /*#__PURE__*/React.createElement(IconCaret, {
      style: {
        transform: expanded ? "rotate(90deg)" : ""
      }
    }), /*#__PURE__*/React.createElement(P, {
      style: {
        paddingLeft: "8px"
      }
    }, expanded ? /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "label.hide_more_concerts",
      defaultMessage: "Hide additional concerts"
    }) : /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "label.show_more_concerts",
      defaultMessage: "Show additional concerts"
    }), " ", "(", sortedRemaining.length, ")")), expanded && sortedRemaining.map(concert => /*#__PURE__*/React.createElement(Concert, _extends({
      key: concert.id
    }, concert, {
      value: value,
      setValue: handleSetValue
    })))), !expanded && sortedRemaining.filter(({
      id
    }) => value.find(checkedId => checkedId === id)).map(concert => /*#__PURE__*/React.createElement(Concert, _extends({
      key: concert.id
    }, concert, {
      value: value,
      setValue: handleSetValue
    }))), (matches.large || value.includes(NOT_ATTENDING)) && /*#__PURE__*/React.createElement(ResponsiveCheckbox, {
      "data-javelin-name": value.includes(NOT_ATTENDING) ? "remove-concert" : "add-concert",
      "data-javelin-meta": "not-attending",
      title: formatMessage({
        id: "label.not_attending",
        defaultMessage: "I'm not attending a concert"
      }),
      onChange: handleNotAttending,
      checked: value.includes(NOT_ATTENDING)
    }, formatMessage({
      id: "label.still_build",
      defaultMessage: "(But I still want to build a custom playlist)"
    })), !matches.large && /*#__PURE__*/React.createElement(FlexBox, {
      style: {
        justifyContent: "center",
        padding: "12px 0"
      }
    }, /*#__PURE__*/React.createElement(Link, {
      onClick: handleNext,
      "data-javelin-name": "not-attending-mobile-link"
    }, formatMessage({
      id: "label.not_attending",
      defaultMessage: "I'm not attending a concert"
    }))));
  }
});